export default "__VITE_ASSET__yen95AJv__"